import React from "react";
import { Box, Container, Grid, Skeleton } from "@mui/material";

const ActivitiesSkeleton = () => {
  return (
    <>
      {/* Skeleton for Page Header */}
      <Box
        sx={{
          backgroundImage: "linear-gradient(to right, #0B0F19, #1A2E55)",
          color: "#FFFFFF",
          paddingY: "100px",
          textAlign: "center",
        }}
      >
        <Container maxWidth="lg">
          <Skeleton
            variant="text"
            width={300}
            height={40}
            sx={{
              margin: "0 auto",
              backgroundColor: "rgba(255, 255, 255, 0.3)",
            }}
          />
          <Skeleton
            variant="text"
            width={600}
            height={24}
            sx={{
              margin: "16px auto",
              backgroundColor: "rgba(255, 255, 255, 0.3)",
            }}
          />
        </Container>
      </Box>

      {/* Skeleton for Activities Grid */}
      <Box
        sx={{
          backgroundImage: "linear-gradient(to right, #0B0F19, #1A2E55)",
          color: "#FFFFFF",
          paddingY: "100px",
        }}
      >
        <Container maxWidth="lg">
          <Grid container spacing={6}>
            {[1, 2, 3, 4, 5, 6].map((item) => (
              <Grid item xs={12} sm={6} md={4} key={item}>
                <Box sx={{ position: "relative" }}>
                  <Skeleton
                    variant="rectangular"
                    height={300}
                    sx={{
                      borderRadius: "20px",
                      backgroundColor: "rgba(255, 255, 255, 0.2)",
                    }}
                  />
                  <Skeleton
                    variant="text"
                    height={30}
                    width="60%"
                    sx={{
                      marginTop: "16px",
                      backgroundColor: "rgba(255, 255, 255, 0.3)",
                    }}
                  />
                  <Skeleton
                    variant="text"
                    height={20}
                    width="40%"
                    sx={{
                      marginTop: "8px",
                      backgroundColor: "rgba(255, 255, 255, 0.3)",
                    }}
                  />
                </Box>
              </Grid>
            ))}
          </Grid>
        </Container>
      </Box>
    </>
  );
};

export default ActivitiesSkeleton;
